import React from "react";
import {
  Button,
  Text,
  makeStyles,
  tokens,
} from "@fluentui/react-components";
import {
  ArrowClockwise24Regular,
  ShieldError32Regular,
} from "@fluentui/react-icons";
import { useAdminAuth } from "./AdminAuthContext";
 
const useStyles = makeStyles({
  container: {
    height: "100vh",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    gap: "18px",
    textAlign: "center",
    padding: "0 24px",
  },
  icon: {
    color: tokens.colorPaletteRedForeground2,
  },
  title: {
    fontSize: "24px",
    fontWeight: "600",
  },
  description: {
    fontSize: "16px",
    color: tokens.colorNeutralForeground2,
    maxWidth: "480px",
  },
  noteBox: {
    marginTop: "12px",
    padding: "16px",
    borderRadius: tokens.borderRadiusMedium,
    backgroundColor: tokens.colorNeutralBackground2,
    border: `1px solid ${tokens.colorNeutralStroke2}`,
    maxWidth: "520px",
    textAlign: "left",
  },
  noteTitle: {
    fontWeight: 600,
    marginBottom: "6px",
  },
  noteText: {
    fontSize: "14px",
    color: tokens.colorNeutralForeground2,
    lineHeight: "1.5",
  },
});
 
function AccessDenied() {
  const styles = useStyles();
   const { logout } = useAdminAuth();
 
  const handleRefresh = () => {
    try {
      logout();
    } catch (err) {
      console.error("Failed to refresh session:", err);
    }
  };
 
  return (
    <div className={styles.container}>
      <ShieldError32Regular className={styles.icon} />
 
      <Text className={styles.title}>
        Access Denied
      </Text>
 
      <Text className={styles.description}>
        You don’t have permission to access the Unaric Voice for Teams Admin Portal.
      </Text>
 
      {/* 🔹 Professional Note Section */}
      <div className={styles.noteBox}>
        <Text className={styles.noteTitle}>
          Note
        </Text>
        <Text className={styles.noteText}>
          : To access this portal, your Azure account must be assigned
          the <strong>Admin</strong> role under Azure Role-Based
          Access Control (RBAC) for Unaric Voice for Teams Client App.
          <br /><br />
          If you believe you should have access, please contact your
          Azure Administrator to request the appropriate role
          assignment.
        </Text>
      </div>
 
      <Button
        appearance="primary"
        icon={<ArrowClockwise24Regular />}
        onClick={handleRefresh}
      >
        Refresh Session
      </Button>
    </div>
  );
}
 
export default AccessDenied;